
import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import vClickOutside from 'v-click-outside'
import PortalContainer from '@/mobile/src/components/containers/PortalContainer.vue'

type Mode = 'click' | 'mouseover'

@Component<Dropdown>({
    directives: {
        clickOutside: vClickOutside.directive,
    },
    components: { PortalContainer },
})
export default class Dropdown extends Vue {
    public opened = false
    // we utilise portal-vue to optionally mount our content to a different place of the DOM tree,
    // mainly so we can display it correctly, esp for fixed position,
    // safari doesn't support 100vh properly when its deep down the DOM tree.
    private portalDisabled = true
    private portalEl: HTMLElement | null = null

    @Prop({ type: Boolean, default: false }) public right?: boolean
    @Prop({ type: Boolean, default: false }) public left?: boolean
    @Prop({ type: Boolean, default: false }) public modal?: boolean
    @Prop({ type: Boolean, default: false }) public disabled?: boolean
    @Prop({ type: String, default: 'click' }) public mode?: Mode
    @Prop(Function) public onOpen!: () => any
    @Prop({ type: Boolean, default: false }) public closed!: boolean

    protected rightOverride = false

    @Watch('closed')
    public watchClosed() {
        this.opened = !this.closed
    }
    private mounted() {
        this.portalEl = document.getElementById('portal-destination')
        this.portalDisabled = !this.modal || !this.portalEl
    }

    public open() {
        if (this.disabled) {
            return
        }
        this.opened = true
        if (this.onOpen) {
            this.onOpen()

            // required to get $refs content element within v-if
            // runs checkAlignment in the next render cycle
            Vue.nextTick(() => {
                this.checkAlignment()
            })
        }
    }

    public toggle() {
        if (this.opened) {
            this.opened = false
        } else {
            this.open()
        }
    }

    public checkAlignment() {
        const content = this.$refs.content as Element

        if (!content || !content.parentElement) {
            return
        }

        this.rightOverride =
            !this.left &&
            content.parentElement.offsetLeft + content.clientWidth >
                window.innerWidth
    }

    private clickOutside(e) {
        if (
            !this.portalDisabled &&
            this.portalEl &&
            this.portalEl.contains(e.target)
        ) {
            return
        }
        this.opened = false
    }
}
